import { useState, useEffect } from "react";
import { feedbackService } from "services/feedback.service";
import { useSessionData } from "helpers";

export function useProfilePictureUrl(profilePicturePath: string | null | undefined): string | null {
  const { business_id, device_token, session_id } = useSessionData();
  const [url, setUrl] = useState<string | null>(null);

  const pathKey = typeof profilePicturePath === "string" ? profilePicturePath : null;

  useEffect(() => {
    const path = typeof profilePicturePath === "string" ? profilePicturePath.trim() : "";
    if (!path) {
      setUrl(null);
      return;
    }
    if (path.startsWith("http://") || path.startsWith("https://")) {
      setUrl(path);
      return;
    }
    if (!business_id || !device_token || !session_id) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    feedbackService
      .getDownloadInfo({
        business_id,
        device_token,
        session_id,
        doc_file_path: path,
      })
      .then((res) => {
        if (cancelled) return;
        if (res?.success && res?.data?.download_info) {
          setUrl(res.data.download_info);
        } else {
          setUrl(null);
        }
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [pathKey, profilePicturePath, business_id, device_token, session_id]);

  return url;
}
